import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { FiChevronDown, FiChevronRight } from 'react-icons/fi';
import './Sidebar.css';

const NavItem = ({ to, icon: Icon, label, submenu }) => {
  const [isOpen, setIsOpen] = useState(false);

  const hasSubmenu = submenu && submenu.length > 0;

  const toggleSubmenu = (e) => {
    e.preventDefault();
    setIsOpen(!isOpen);
  };

  if (hasSubmenu) {
    return (
      <div>
        <NavLink 
          to={to}
          className={({ isActive }) => isActive ? 'nav-item active' : 'nav-item'}
          onClick={(e) => {
            e.preventDefault();
            toggleSubmenu(e);
          }}
        >
          <Icon className="nav-icon" />
          <span>{label}</span>
          {isOpen ? <FiChevronDown className="submenu-icon" /> : <FiChevronRight className="submenu-icon" />}
        </NavLink>
        {isOpen && (
          <div className="submenu">
            {submenu.map((item) => (
              item.external ? (
                <a 
                  key={item.externalUrl} 
                  href={item.externalUrl} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="nav-item submenu-item"
                >
                  {item.label}
                </a>
              ) : (
                <NavLink 
                  key={item.to} 
                  to={item.to} 
                  className={({ isActive }) => isActive ? 'nav-item submenu-item active' : 'nav-item submenu-item'}
                >
                  {item.label}
                </NavLink>
              )
            ))}
          </div>
        )}
      </div>
    );
  }

  return (
    <NavLink 
      to={to} 
      className={({ isActive }) => isActive ? 'nav-item active' : 'nav-item'}
    >
      <Icon className="nav-icon" />
      <span>{label}</span>
    </NavLink>
  );
};

export default NavItem;
